<template>
    <!DOCTYPE html>
    <html>
        <!-- begin page header -->
        <head>
            <Header />
            <slot name="head"></slot>
        </head>
        <!-- end of page header -->

        <body>
            <div class="wrapper">
                <!-- nav div begin -->
                <Navbar ref="navbar" />
                <!-- nav div end -->

                <div class="">
                    <div class="row" v-bind:class="{ blur : toBlur }">
                        <!-- side menu begin -->

                        <!-- side menu end -->

                        <div class="col col-lg-12">
                            <!-- user greetings div -->
                            <ContentHeader class="d-none d-lg-flex" />
                            <SideMenu class="d-none d-lg-block"/>
                            <!-- user page title div -->
                            <div class="px-2">
                                <div class="row py-3">
                                    <div class="col-12 col-xl-10 offset-xl-1">
                                        <h3 class="tableau-de-bord mt-3"><strong>{{content_title}}</strong></h3>
                                    </div>
                                </div>

                                <slot name="page-sub-title"></slot>

                                <!-- user begin component contents div -->
                                <div class="overflow-auto gx-5 row row-perso">
                                    <slot></slot>
                                    <Footer />
                                </div>
                                <!-- end content components div -->
                            </div>
                        </div>
                    </div>
                </div>
                <slot name="modals"></slot>
            </div>

            <Loading />
            <AdvisorFloat v-if="!isMyAdvisor"/>
        </body>
    </html>
</template>

<script>
import Header from "../components/Header.vue";
import Navbar from "../components/Navbar.vue";
import SideMenu from "../components/SideMenu.vue";
import AdvisorFloat from "../components/AdvisorFloat.vue";
import Footer from "../components/Footer.vue"
import ContentHeader from "../components/Common/ContentHeader.vue"
import Loading from "../components/Common/Loading.vue";

export default {
  components: {
    Header,
    Navbar,
    SideMenu,
    Footer,
    ContentHeader,
    Loading,
    AdvisorFloat,
},
  props: {
    content_title: String,
    toBlur: Boolean
  },
  computed: {
    isMyAdvisor() {
      return this.$route.path === '/mon-conseiller';
    },
  },
};
</script>

<style scoped lang="scss">
    @media only screen and (min-device-width: 768px) {
        .gx-perso{
            --bs-gutter-x: 15rem;
        }
    }

    @media only screen and (max-device-width: 768px) {
        .gx-perso{
            --bs-gutter-x: 1rem;
        }
    } 

    @media only screen and (min-device-width: 768px) {
        .row-perso {
            --bs-gutter-x: 8.5rem;
            --bs-gutter-y: 0;
            display: flex;
            flex-wrap: wrap;
            margin-top: calc(var(--bs-gutter-y)* -1);
            margin-right: calc(var(--bs-gutter-x)* -1);
            margin-left: calc(var(--bs-gutter-x)* 0);
        }
    }

    @media only screen and (max-device-width: 768px) {
        .row-perso {
            --bs-gutter-x: 0rem;
            --bs-gutter-y: 0;
            display: flex;
            flex-wrap: wrap;
            margin-top: calc(var(--bs-gutter-y)* -1);
            margin-right: calc(var(--bs-gutter-x)* -1);
            margin-left: calc(var(--bs-gutter-x)* 0);
        }
    }
</style>
